const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/layout/App/styles.ts';
import { css } from '@emotion/css';
import { theme } from 'App/utils/clientSetupManager';

export const contentAreaStyle = css`
    display: flex;
    flex-direction: column;
    label: contentArea;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    ${theme?.breakpoints?.down && theme.breakpoints.down('sm')} {
        overflow-y: auto;
    }
    overflow: hidden;
`;
